import React from 'react';
import { Link } from 'react-router-dom';

function Accreditation() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      {/* HEADER HERO SECTION */}
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Global Medical Tourism Accreditation Guide: How to Verify Hospital Quality Abroad
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '25px' }}>
          Traveling to another country for complex medical treatments, major dental overhauls, or specialized surgeries requires absolute certainty regarding patient safety protocols. For global medical travelers, understanding **healthcare accreditation frameworks** is the single most important factor in distinguishing top-tier clinical environments from unverified options. 
          This comprehensive research guide highlights how independent platforms like <strong>Medical Trip World</strong> help patients study international hospital safety standards, clinical benchmark registries, and global quality stamps.
        </p>
      </header>

      {/* CALL TO ACTION BUTTON */}
      <div style={{ marginBottom: '35px' }}>
        <Link to="/submit-query" style={{ 
          background: '#28a745', 
          color: '#fff', 
          padding: '14px 24px', 
          textDecoration: 'none', 
          borderRadius: '4px', 
          fontWeight: 'bold', 
          display: 'inline-block', 
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          fontSize: '0.95rem',
          textAlign: 'center',
          boxSizing: 'border-box',
          maxWidth: '100%'
        }}>
          Access Independent Hospital Verification Checklist (Free) →
        </Link>
      </div>

      {/* SECTION 1: KEY ACCREDITATION BODIES */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #f4f8fb', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Primary International Healthcare Quality Standards to Search For
        </h2>
        <p style={{ color: '#555', lineHeight: '1.7', marginBottom: '15px', fontSize: '0.95rem' }}>
          When reviewing global destinations, look for healthcare facilities audited by recognized, third-party international quality boards. These certifications verify that an overseas hospital adheres to strict surgical safety, infection control, and clinical tracking systems.
        </p>
        
        <div style={{ padding: '5px 0' }}>
          <h3 style={{ color: '#0b3c5d', fontSize: '1.25rem', margin: '10px 0 5px 0' }}>1. Joint Commission International (JCI)</h3>
          <p style={{ color: '#555', lineHeight: '1.6', margin: 0, fontSize: '0.95rem' }}>
            Based in the United States, JCI represents the gold standard for global healthcare accreditation. A JCI-accredited facility undergoes rigorous on-site evaluations testing over 300 rigorous standards, ranging from surgical checklist execution to medical staff credential validation.
          </p>
        </div>

        <div style={{ padding: '5px 0' }}>
          <h3 style={{ color: '#0b3c5d', fontSize: '1.25rem', margin: '15px 0 5px 0' }}>2. National Accreditation Board for Hospitals & Healthcare Providers (NABH)</h3>
          <p style={{ color: '#555', lineHeight: '1.6', margin: 0, fontSize: '0.95rem' }}>
            Operating as a constituent board of the Quality Council of India, NABH is a rigorous benchmark specifically designed for South Asian medical infrastructure. It targets patient safety metrics, nursing ratios, and ICU care ecosystems to fulfill modern clinical expectations.
          </p>
        </div>
      </section>

      {/* SECTION 2: COMPARATIVE FRAMEWORK TABLE - MADE MOBILE SAFE */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #f4f8fb', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          At-a-Glance: Comparing Major Healthcare Standards Matrix
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          The structure below breaks down how international and localized national accreditation stamps compare across standard medical travel metrics:
        </p>

        <div style={{ background: '#f4f8fb', padding: 'clamp(12px, 4vw, 20px)', margin: '25px 0', borderRadius: '4px', borderLeft: '4px solid #005ba1' }}>
          <h3 style={{ marginTop: '0', color: '#005ba1', fontSize: '1.2rem', marginBottom: '10px' }}>📊 Clinical Quality Evaluation Benchmarks:</h3>
          
          {/* Scrollable Container Protective Box */}
          <div style={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch', margin: '15px 0 5px 0' }}>
            <table style={{ width: '100%', minWidth: '600px', borderCollapse: 'collapse', color: '#333', textAlign: 'left', fontSize: '0.9rem' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #ddd' }}>
                  <th style={{ padding: '10px 8px' }}>Quality Metric Tested</th>
                  <th style={{ padding: '10px 8px' }}>JCI Certified Hubs</th>
                  <th style={{ padding: '10px 8px' }}>NABH Certified Hubs</th>
                  <th style={{ padding: '10px 8px' }}>Unaccredited Facilities</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 8px' }}><strong>Infection Control Procedures</strong></td>
                  <td style={{ padding: '10px 8px' }}>Strict Global Protocols</td>
                  <td style={{ padding: '10px 8px' }}>Strict National Protocols</td>
                  <td style={{ padding: '10px 8px', color: '#d9534f' }}>Highly Variable / Unverified</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 8px' }}><strong>Surgeon Credential Audit</strong></td>
                  <td style={{ padding: '10px 8px' }}>Mandatory Board Reviews</td>
                  <td style={{ padding: '10px 8px' }}>Mandatory Verified Logs</td>
                  <td style={{ padding: '10px 8px', color: '#d9534f' }}>No Regular Third-Party Review</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 8px' }}><strong>International ICU Framework</strong></td>
                  <td style={{ padding: '10px 8px' }}>Required Smart Systems</td>
                  <td style={{ padding: '10px 8px' }}>Standard Specialized Units</td>
                  <td style={{ padding: '10px 8px', color: '#d9534f' }}>Basic Baseline Support Only</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <p style={{ margin: '10px 0 0 0', fontSize: '0.8rem', color: '#666', lineHeight: '1.5' }}>
            <em>*Data Notice: The information presented above is synthesized from public medical auditing manuals. Because configurations change, patients should request active verification tracking directly from their final clinical provider prior to traveling.</em>
          </p>
        </div>
      </section>

      {/* SECTION 3: CORE PATIENT CONCERNS - BREAKS TO COLUMN AT < 600px */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #f4f8fb', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Essential Checkpoints to Independently Verify Hospital Safety
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Because Medical Trip World operates purely as an independent reference platform, we encourage traveling patients to maintain maximum research diligence by directly assessing prospective centers on the following fronts:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginTop: '15px' }}>
          <div style={{ padding: '15px', background: '#fafafa', borderRadius: '4px', border: '1px solid #eee' }}>
            <h4 style={{ margin: '0 0 8px 0', color: '#0b3c5d', fontSize: '1.05rem' }}>Active Accreditation Registries</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Do not rely solely on badges posted on websites. Cross-reference the official Joint Commission International public directory to verify that a medical facility’s license is currently active and not suspended or expired.
            </p>
          </div>
          <div style={{ padding: '15px', background: '#fafafa', borderRadius: '4px', border: '1px solid #eee' }}>
            <h4 style={{ margin: '0 0 8px 0', color: '#0b3c5d', fontSize: '1.05rem' }}>Language Support and Coordination</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Accredited international destination hubs maintain dedicated international patient wings equipped with medical translators to verify clear communication regarding diagnostic insights and informed consent documentation.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4: IN-DEPTH FAQ */}
      <section style={{ marginBottom: '35px', background: '#fff', border: '1px solid #e0e0e0', padding: 'clamp(15px, 4vw, 20px)', borderRadius: '4px' }}>
        <h3 style={{ color: '#0b3c5d', marginTop: '0', marginBottom: '20px', fontSize: '1.25rem' }}>
          Frequently Asked Questions (FAQs) – Healthcare Standards Abroad
        </h3>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 5px 0', fontSize: '0.95rem' }}>Are clinical outcomes at JCI-accredited facilities comparable to Western hospitals?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Yes. JCI-accredited institutions utilize identical care frameworks, surgical checklists, and medication management parameters as premier private medical centers in North America and Western Europe, aiming for comparable safety metrics.
          </p>
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 5px 0', fontSize: '0.95rem' }}>How can a patient check if a specific surgeon is qualified?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Patients can request a surgeon’s clinical curriculum vitae (CV), board certifications, and active surgical history logs. Accredited institutions readily facilitate this transparency to assist patient verification steps.
          </p>
        </div>
        
        <div style={{ marginBottom: '5px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 5px 0', fontSize: '0.95rem' }}>Does Medical Trip World officially certify these overseas hospitals?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. Medical Trip World is an independent informational guide and directory. We do not provide official endorsements, run clinical site audits, or maintain formal partnerships or MOUs with medical networks. All bookings, clinical screening, and contract agreements occur directly between the patient and the healthcare facility.
          </p>
        </div>
      </section>

      {/* RE-ENGAGEMENT FOOTER - BUTTONS RE-ARRANGED FOR MOBILE SWIPES */}
      <footer style={{ borderTop: '1px solid #eee', paddingTop: '20px', textAlign: 'center' }}>
        <p style={{ fontSize: '1.05rem', fontWeight: 'bold', color: '#333', margin: '0 0 15px 0' }}>Empower Your Global Healthcare Research Journey Safely</p>
        <div style={{ display: 'flex', gap: '12px', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          <style>{`
            @media (max-width: 550px) {
              .footer-btn { width: 100% !important; text-align: center; box-sizing: border-box; }
            }
          `}</style>
          <Link to="/submit-query" className="footer-btn" style={{ background: '#28a745', color: '#fff', padding: '12px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            Submit General Information Request
          </Link>
          <Link to="/compare-costs" className="footer-btn" style={{ background: '#fff', color: '#0b3c5d', border: '2px solid #0b3c5d', padding: '10px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            View Estimated Cost Charts
          </Link>
        </div>
      </footer>

    </article>
  );
}

export default Accreditation;